/* eslint-disable no-param-reassign */
/* global HERE_APP_ID, HERE_APP_CODE, IS_PRODUCTION */
import axios from "axios";

// "q" is the search query
function generateRequest(url, userGeolocation, q, urlParams) {
  return axios({
    method: "GET",
    url,
    headers: userGeolocation.available
      ? {
          Geolocation: `geo:${userGeolocation.coordinates.lat},${
            userGeolocation.coordinates.lng
          };cgen=gps`
        }
      : {},
    params: {
      app_id: HERE_APP_ID,
      app_code: HERE_APP_CODE,
      q,
      pretty: true,
      tf: "plain",
      ...urlParams
    }
  });
}

export default {
  autocompleteAddress(q) {
    // hardcode milford as location in dev mode or if we don't have user's location
    const userGeolocation = {
      available: true,
      coordinates: {
        lat: "41.2306979",
        lng: "-73.064036"
      }
    };

    return generateRequest(
      "https://places.cit.api.here.com/places/v1/autosuggest",
      userGeolocation,
      q,
      {
        result_types: "address",
        size: 10,
        cs: "pds",
        addressFilter: "countryCode=USA"
      }
    );
  },
  placeSearch(userGeolocation, q) {
    return generateRequest(
      "https://places.cit.api.here.com/places/v1/discover/search",
      userGeolocation,
      q,
      { size: 10 }
    );
  },
  citySearch(searchText, urlParams) {
    return axios({
      method: "GET",
      url: "https://geocoder.api.here.com/6.2/geocode.json",
      params: {
        app_id: HERE_APP_ID,
        app_code: HERE_APP_CODE,
        addressattributes: "city,state",
        locationattributes: "address",
        country: "USA",
        searchText,
        ...urlParams
      }
    });
  },
  reverseGeocode({ lat, lng }) {
    return axios({
      method: "GET",
      url: "https://reverse.geocoder.api.here.com/6.2/reversegeocode.json",
      params: {
        app_id: HERE_APP_ID,
        app_code: HERE_APP_CODE,
        addressattributes: "city,state",
        locationattributes: "address",
        country: "USA",
        mode: "retrieveAddresses",
        prox: `${lat},${lng}`
      }
    });
  },
  formatResponseAddress(place) {
    const {
      street,
      city,
      stateCode,
      postalCode,
      countryCode,
      house
    } = place.location.address;
    const [lat, lng] = place.location.position;

    return {
      address: {
        street: `${house} ${street}`,
        city,
        state: stateCode,
        postalCode,
        country: countryCode
      },
      coordinates: {
        lat,
        lng
      }
    };
  },
  formatResponseAddressAlt(location) {
    const {
      Street,
      City,
      State,
      PostalCode,
      Country,
      HouseNumber
    } = location.Address;
    const { Latitude, Longitude } = location.DisplayPosition;

    return {
      address: {
        street: `${HouseNumber} ${Street}`,
        city: City,
        state: State,
        postalCode: PostalCode,
        country: Country
      },
      coordinates: {
        lat: Latitude,
        lng: Longitude
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/helpers/placesAPI.js